import {MtMarker} from "./mtmarker";
import * as Collections from 'typescript-collections';

export class MtMarkerGroupCollection {

    private _markersDic: Collections.Dictionary<string, Collections.Dictionary<string, MtMarker>>;
    private _defGroup = "defaultGroup"

    constructor() {
        this._markersDic = new Collections.Dictionary<string, Collections.Dictionary<string, MtMarker>>();
    }

    get defaultGroup() {
        return this._defGroup;
    }

    addMarker(marker: MtMarker, group: string = this._defGroup): MtMarkerGroupCollection {
        this.addAllMarkers([marker], group);
        return this;
    }

    /**
     * Adiciona los markers que no existen en la coleccion y retorna los markers adicionados.
     * @param markers
     * @param group
     * @return MtMarker[]
     */
    addAllMarkers(markers: MtMarker[], group: string = this._defGroup) {
        if (markers) {
            var added = [];
            var groupDict = this._ensureGroup(group);
            markers.forEach((mk) => {
                if (mk != void 0 && !groupDict.containsKey(mk.getId())) {
                    groupDict.setValue(mk.getId(), mk);
                    added.push(mk);
                }
            });
            return added;
        }
    }

    removeMarkerById(id: any, group: string = this._defGroup): MtMarker {
        if (this._markersDic.containsKey(group)) {
            return this._markersDic.getValue(group).remove(id);
        }
    }

    removeMarker(marker: MtMarker, group: string): MtMarker {
        return this.removeMarkerById(marker.getId(), group);
    }

    removeMarkers(markers: MtMarker[], group: string): MtMarker[] {
        if (markers) {
            var ids = markers.map((mk) => {
                return mk.getId();
            });
            return this.removeMarkersById(ids, group);
        }
        return [];
    }

    removeMarkersById(ids: string[], group: string = this._defGroup): MtMarker[] {
        if (!ids || !(ids instanceof Array)) {
            throw Error("removeMarkersById: The first argument must be an array with the marker ids.");
        }
        let removed = [];
        ids.forEach((id) => {
            removed.push(this.removeMarkerById(id, group));
        });
        return removed;
    }

    removeGroup(group: string): MtMarker[] {
        if (!group || typeof  group != 'string') {
            throw new Error("removeGroup: The group argument must be an string.");
        }
        let resp;
        if (this.getGroup(group)) {
            resp = this.getGroup(group).values();
            this.getGroup(group).clear();
        } else {
            resp = []
        }
        return resp;
    }

    clear() {
        this._markersDic.clear();
    }

    getMarker(id: any, group?: string): MtMarker {
        if (group != void 0) {
            if (this._markersDic.getValue(group) != void 0) {
                return this._markersDic.getValue(group).getValue(id);
            }
        } else {
            var dicts = this._markersDic.values();
            for (var i = 0; i < dicts.length; i++) {
                var d = dicts[i];
                if (d.containsKey(id)) {
                    return d.getValue(id);
                }
            }
        }
    }

    getCount(group?: string): number {
        if (group != void 0) {
            if (!this._markersDic.containsKey(group)) throw new Error("The marker group " + group + "doesn't exist.");
            return this._markersDic.size();
        } else {
            return this._markersDic.values().reduce((sum: any, dic) => {
                return sum + dic.size();
            }, 0);
        }
    }

    getGroup(group: string = this._defGroup): Collections.Dictionary<string, MtMarker> {
        return this._ensureGroup(group);
    }

    contains(id: any): boolean {
        var groups = this._markersDic.values();
        for (var i = 0; i < groups.length; i++) {
            var g = groups[i];
            if (g.containsKey(id)) {
                return true;
            }
        }
        return false;
    }

    toArray(): MtMarker[] {
        return this._markersDic.values().reduce((acum: any, current) => {
            return (<any[]>acum).concat(current.values());
        }, []);
    }

    _ensureGroup(group: string): Collections.Dictionary<string, MtMarker> {
        if (!this._markersDic.getValue(group)) {
            this._markersDic.setValue(group, new Collections.Dictionary<string, MtMarker>());
        }
        return this._markersDic.getValue(group);
    }
}


// WEBPACK FOOTER //
// ./src/mkcollection.ts